import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const StarredSpacesEmptyStateLoader: LoadableType<{ onExploreSpacesClick: () => void }> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-StarredSpacesEmptyState" */
					'./StarredSpacesEmptyState.tsx'
				)
			).StarredSpacesEmptyState,
	});
